<template lang="html">
  <div class="">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar tab='3'></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <common-crud ref="crud"
            :searchData="searchData"
            :tableData.sync="emailTemplateData"
            :addNewOrEditData="addNewOrEditData"
            :crudApi="crudApi"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            editSuccessMessages="编辑邮件模板成功"
          >
            <template slot="result">
              <el-table-column sortable prop="templateCode" label="模板Code" width="120">
              </el-table-column>
              <el-table-column sortable prop="templateName" label="模板标题" min-width="300">
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="操作时间">
              </el-table-column>                            
              <el-table-column sortable prop="updateBy" label="操作人">
              </el-table-column>                                          
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">公告信息</template>
            <template slot="editForm">
                <el-row>
                  <div class="col-full">
                    <el-form-item label="模板Code" prop="templateCode">
                      <el-input disabled v-model="addNewOrEditData.templateCode" placeholder=""></el-input>
                    </el-form-item>
                  </div>
                </el-row>
                <el-row>
                  <div class="col-full">
                    <el-form-item required label="模板标题" prop="templateName">
                      <el-input v-model="addNewOrEditData.templateName" placeholder="请输入模板标题"></el-input>
                    </el-form-item>
                  </div>
                </el-row>
                <el-row>
                  <div class="col-full">
                    <el-form-item label="模板标题" prop="templateContent">
                      <common-editor ref="editor" v-model="addNewOrEditData.templateContent" editorHeight="300"></common-editor>
                    </el-form-item>
                  </div>
                </el-row>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存邮件模板？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailtemplateApi from '@/api/sysmanagement/emailtemplate';
import LeftBar from '../LeftBar';

export default {
  components: {
    LeftBar
  },
  data() {
    return {
      emailTemplateData :[],
      searchData: {},
      addNewOrEditData: {
        templateCode: '',
        templateName: '',
        templateContent: '',

      },
      crudApi: emailtemplateApi,
    }
  },
  methods: {
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);      
    },
    handleEditClick(item) {      
      this.$refs['crud'].handleEdit(item);
      if(this.$refs.editor){
        this.$refs.editor.refresh();
      }
    },
    beforeSave(saveData) {
    },
  },  
  mounted() {    
    this.handleSearch();  
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      display: flex;

      .el-row {
        .col-full {
          width: 698px;
        }

        .el-col {
          width: 220px;
        }

        .el-col + .el-col {
          margin-left: 28px;
        }
      }
      
      .search-btn {
        margin-top: 125px;
        margin-left: 14px;

        button {
          width: 120px;
        }
      }
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;

    .add-btn {
      width: 120px;
    }

    .batch-download-btn, .batch-delete-btn {
      width: 87px;
      padding: 0;
    }

    .el-button + .el-button {
       margin-left: 26px;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?1c90bbc6